module.exports = __webpack_public_path__ + "img/main2.ff50b46c.png";